export default __webpack_public_path__ + "static/go@768-320a9413ab0d15a0cc1d3b75baf3c620.svg";